// extracted by mini-css-extract-plugin
export var legendIndicator = "_cs-1";
export var legendRight = "_cs-0";